// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lo3M9","newExpiryDate":"styles_newExpiryDate__2_pf4","footer":"styles_footer__2EIUE"};